import { ProposalList } from "./ProposalList";
import { ProposalShow } from "./ProposalShow";
import { ProposalCreate } from "./ProposalCreate";

export default {
  list: ProposalList,
  show: ProposalShow,
  create: ProposalCreate,
};
